import React from "react";
// React Table
import { Container } from "react-bootstrap";

const VistaDescripcionObra = ({ descripcionMision }) => {
  return (
    <Container>
      <p>{descripcionMision || <small>No especificado</small>}</p>
    </Container>
  );
};

export default VistaDescripcionObra;
